import { useProgramSession } from '../../../../data/hooks/schedule/useProgramSession';
import { useEventSchedule } from '../../../../data/hooks/schedule/useEventSchedule';

export function useProgramImpliedSessions(eventId, itemId) {
    const item = useProgramSession(eventId, itemId),
        impliedSessionsIds = item.implied ?? [],
        impliedSessionsFilter = (session) => impliedSessionsIds.some((id) => id == session.id),
        impliedSessions = useEventSchedule(eventId, { filter: impliedSessionsFilter });

    return impliedSessions;
}
